import React, { useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./Footer.scss";
import Popup from "../Popup/Popup";
import HubSpotMeetingIframe from "../HubspotMeeting/HubspotMeeting";

const Footer = () => {
  const [showMeeting, setShowMeeting] = useState(false);

  return (
    <React.Fragment>
      <footer className="bg-navy py-3 py-md-4 mt-5 mt-lg-7rem">
        <Container>
          <Row className="text-white">
            <Col xs={12} lg={7}>
              <Row className="p-3">
                <Col xs={12} md={6} className="mb-3 ps-md-0">
                  <div className="bg-white-transparent text-start">
                    <Image
                      loading="lazy"
                      decoding="async"
                      src="/assets/icon-footer/maps.svg"
                      alt="Adresse"
                    />
                    <span className="ps-2 text-white font-s">
                      1 Terrasse Bellini 92800 Puteaux
                    </span>
                  </div>
                </Col>
                <Col xs={12} md={6} className="mb-3 ps-md-0">
                  <a href="tel:+33980807949" className="text-decoration-none">
                    <div className="bg-white-transparent text-start">
                      <Image
                        loading="lazy"
                        decoding="async"
                        src="/assets/icon-footer/phone.svg"
                        alt="Téléphone"
                      />
                      <span className="ps-2 text-white font-s">
                        +33 9 80 80 79 49
                      </span>
                    </div>
                  </a>
                </Col>
                <Col xs={12} md={6} className="mb-3 ps-md-0">
                  <a
                    href="https://liora.io/evenements"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none"
                  >
                    <div className="bg-white-transparent text-start">
                      <Image
                        loading="lazy"
                        decoding="async"
                        src="/assets/icon-footer/event.svg"
                        alt="Évènements"
                      />
                      <span className="ps-2 text-white font-s">
                        Participer aux évènements
                      </span>
                    </div>
                  </a>
                </Col>
                <Col xs={12} md={6} className="mb-3 ps-md-0">
                  <button
                    onClick={() => setShowMeeting(true)}
                    className="text-decoration-none bg-transparent border-0 w-100 p-0 a"
                  >
                    <div className="bg-white-transparent text-start">
                      <Image
                        loading="lazy"
                        decoding="async"
                        src="/assets/icon-footer/calendar.svg"
                        alt="Calendrier"
                      />
                      <span className="ps-2 text-white font-s">
                        Prendre RDV en ligne
                      </span>
                    </div>
                  </button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </footer>

      <Popup
        show={showMeeting}
        onClose={() => setShowMeeting(false)}
        modalTitle="Prendre rendez-vous"
        size="xl"
        scrollable
      >
        <HubSpotMeetingIframe source="https://meetings.hubspot.com/datascientest/fr-dst-lets-discuss-your-project-prise-de-rdv-direct-site?embed=true" />
      </Popup>
    </React.Fragment>
  );
};

export default Footer;
